import React from "react";
import {usePage} from "@inertiajs/inertia-react";
import List from "../List/List";
import ListItem from "../ListItem";
import {Drawer} from "./Drawer";


export const LibraryDrawer = ({ activeTab, setActiveTab, libraryItems }) => {
    const { isLoggedIn, mediaId } = usePage().props;
    if(isLoggedIn) {
        return (
            <Drawer
                drawerId='library'
                activeTab={activeTab}
                setActiveTab={setActiveTab}
            >
                {libraryItems.length === 0
                    ? (
                        <div className='flex flex-col justify-center items-center pt-10 pb-10 px-4'>
                            <img
                                className='mb-4'
                                src='/assets/images/jpm-plus-library-binoculars.png'
                                width='53'
                                height='35'
                                alt='Library Empty'
                            />
                            <h3 className="text-xl text-center mb-4 font-bold">You don't have any digital resources in your library</h3>
                            <p className='text-sm text-center mb-4 px-4'>
                                Check out our latest featured offers for more digital resources
                            </p>
                            <a href='/monthly-offer' as='button' className='btn btn-primary m-auto'>
                                Request Yours Now
                            </a>
                        </div>
                    )
                    :
                    (
                        <>                        
                        <List
                            isLoggedIn={isLoggedIn}
                            elements={libraryItems}
                            pageSize={10}
                            shouldPaginate={true}
                            totalElements={libraryItems.length}
                            viewportWidth={200}
                            listItem={(el) => <ListItem
                                imageUrl={el.thumbnail_url}
                                title={el.title}
                                isHorizontalScroll={false}
                                isLibraryItem={true}
                                link={el.watch_url}
                                isActive={mediaId === el.media_id}
                                mediaType='Digital Resource'
                            />}
                        />
                        <a
                            href='/account/library'
                            className='inline-block mt-3 border-b-primary border-b b-solid leading-6 text-sm'
                        >
                            Back to Library
                        </a>
                        </>
                    )
                }
            </Drawer>
        );
    }

    return (
        <Drawer
            drawerId='library'
            activeTab={activeTab}
            setActiveTab={setActiveTab}
        >
            <div className='flex flex-col justify-center items-center pt-10 pb-10 px-4'>
                <img
                    className='mb-4'
                    src='/assets/images/jpm-plus-library-media-library.png'
                    width='53'
                    height='35'
                    alt='Media Library'
                />
                <h3 className="text-xl text-center mb-4 font-bold">All Your Content In One Place</h3>
                <p className='text-sm text-center mb-4 px-4'>
                    Sign in to access your resources from Joseph Prince Ministries
                </p>
                <a href='#login' as='button' className='btn btn-primary m-auto'>
                    Sign In
                </a>
            </div>
        </Drawer>
    );
};